/* eslint-disable no-useless-escape */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useContext, FC } from 'react'
import { useHistory, withRouter } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import { Button } from '@material-ui/core'
import SignupLayout from '../../layout'
import { SignupContext } from '../../context/SignupContextContainer'
import SIGNUP_STEPS from '../../utils/constants'
import AdminProspectCriteria from '../Dashboard/Settings/ProspectCriteria'

const Criteria: FC<any> = ({ match, location }) => {
  const { setSignupStep } = useContext(SignupContext)
  const history = useHistory()

  const skipStep = (): void => {
    setSignupStep(SIGNUP_STEPS.CONGRATULATIONS)
    history.push('/client/congratulations')
  }

  const setCriteria = (): void => {
    history.push('/client/congratulations')
  }

  return (
    <SignupLayout page="full-page">
      <AdminProspectCriteria {...{ history, match, location }} />
      <div className="button-container column">
        <Button size="medium" color="primary" variant="contained" onClick={setCriteria}>
          Set Criteria
        </Button>
        <Button size="medium" color="primary" className="skipThis" onClick={skipStep}>
          Or Skip for Now
        </Button>
      </div>
    </SignupLayout>
  )
}
export default inject('settings')(withRouter(observer(Criteria)))
